<template>
  <div v-if="loanable" class="mt-4">
    <h3 class="h6">Pour ce véhicule seulement</h3>
    <p class="small text-muted">
      Sans personnalisation, ce véhicule suit le réglage du propriétaire.
    </p>

    <div class="mb-3">
      <b-form-checkbox v-model="expensesCustom" switch>
        Personnaliser les dépenses déclarées
      </b-form-checkbox>
      <b-form-checkbox
        v-if="expensesCustom"
        v-model="expensesValue"
        switch
        class="mt-2 ml-4"
      >
        Les membres peuvent déclarer des dépenses
      </b-form-checkbox>
      <div v-else class="small text-muted ml-4">
        Réglage du propriétaire : {{ inheritedExpenses ? "autorisé" : "refusé" }}.
      </div>
    </div>

    <div>
      <b-form-checkbox v-model="generalInterestCustom" switch>
        Personnaliser les trajets pro ou d'intérêt général
      </b-form-checkbox>
      <b-form-checkbox
        v-if="generalInterestCustom"
        v-model="generalInterestValue"
        switch
        class="mt-2 ml-4"
      >
        L'emprunteur peut déclarer un trajet non facturé
      </b-form-checkbox>
      <div v-else class="small text-muted ml-4">
        Réglage du propriétaire : {{ inheritedGeneralInterest ? "autorisé" : "refusé" }}.
      </div>
    </div>

    <div class="mt-3">
      <b-form-checkbox v-model="maxLoanDaysCustom" switch>
        Personnaliser la durée maximale
      </b-form-checkbox>
      <div v-if="maxLoanDaysCustom" class="mt-2 ml-4">
        <b-input-group append="jours" class="max-loan-days">
          <b-form-input
            v-model.number="maxLoanDaysValue"
            type="number"
            min="1"
            step="1"
          />
        </b-input-group>
      </div>
      <div v-else class="small text-muted ml-4">
        Réglage du propriétaire : {{ inheritedMaxLoanDays }} jours.
      </div>
    </div>
  </div>
</template>

<script>
import { asNullableBool, effectiveSetting } from "@/billingSettings";
import { positiveIntOrNull } from "@/loanDays";

export default {
  name: "LoanableBillingOverrides",
  props: {
    loanable: {
      type: Object,
      default: null,
    },
  },
  computed: {
    inheritedExpenses() {
      return effectiveSetting(
        null,
        this.loanable.owner && this.loanable.owner.allows_declared_expenses,
        true
      );
    },
    inheritedGeneralInterest() {
      return effectiveSetting(
        null,
        this.loanable.owner && this.loanable.owner.allows_general_interest_trips,
        false
      );
    },
    inheritedMaxLoanDays() {
      return positiveIntOrNull(
        this.loanable.owner && this.loanable.owner.max_loan_days
      ) || 3;
    },
    expensesCustom: {
      get() {
        return asNullableBool(this.loanable.allows_declared_expenses) !== null;
      },
      set(enabled) {
        this.$set(
          this.loanable,
          "allows_declared_expenses",
          enabled ? this.inheritedExpenses : null
        );
      },
    },
    expensesValue: {
      get() {
        const own = asNullableBool(this.loanable.allows_declared_expenses);
        return own === null ? this.inheritedExpenses : own;
      },
      set(value) {
        this.$set(this.loanable, "allows_declared_expenses", !!value);
      },
    },
    generalInterestCustom: {
      get() {
        return asNullableBool(this.loanable.allows_general_interest_trips) !== null;
      },
      set(enabled) {
        this.$set(
          this.loanable,
          "allows_general_interest_trips",
          enabled ? this.inheritedGeneralInterest : null
        );
      },
    },
    generalInterestValue: {
      get() {
        const own = asNullableBool(this.loanable.allows_general_interest_trips);
        return own === null ? this.inheritedGeneralInterest : own;
      },
      set(value) {
        this.$set(this.loanable, "allows_general_interest_trips", !!value);
      },
    },
    maxLoanDaysCustom: {
      get() {
        return positiveIntOrNull(this.loanable.max_loan_days) !== null;
      },
      set(enabled) {
        this.$set(
          this.loanable,
          "max_loan_days",
          enabled ? this.inheritedMaxLoanDays : null
        );
      },
    },
    maxLoanDaysValue: {
      get() {
        return (
          positiveIntOrNull(this.loanable.max_loan_days) || this.inheritedMaxLoanDays
        );
      },
      set(value) {
        const days = positiveIntOrNull(value);
        this.$set(
          this.loanable,
          "max_loan_days",
          days === null ? this.inheritedMaxLoanDays : days
        );
      },
    },
  },
};
</script>

<style scoped>
.max-loan-days {
  max-width: 12rem;
}
</style>
